import { render, staticRenderFns } from "./AddEditDumpsterSize.vue?vue&type=template&id=1c38f8b3&"
import script from "./AddEditDumpsterSize.vue?vue&type=script&lang=js&"
export * from "./AddEditDumpsterSize.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDumpsterSize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports